/**
 * Converts a snake_case key to a human-readable "Title Case" label.
 */
export function humanizeKey(key: string): string {
    return key
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
}

/**
 * Formats a single array item for display.
 * Objects are JSON-stringified rather than coerced via String() (which yields "[object Object]").
 */
function formatArrayItem(item: unknown): string {
    if (item !== null && typeof item === "object") return JSON.stringify(item);
    return String(item);
}

/**
 * Formats an array value for display as a comma-separated string.
 * Returns "—" for null, undefined, or empty arrays.
 */
export function formatArrayValue(value: unknown[]): string {
    if (value.length === 0) return "—";
    return value.map(formatArrayItem).join(", ");
}
